module.exports = __webpack_public_path__ + "img/medical_sociology.f1437d5f.svg";